import http from '../../plugins/axios';

export default {

    /**净充值统计*/
    getNetDepositStatisticInfo(data) {
        return http.get({
            url: '/admin/tradeStatistic/netDeposit',
            data
        })
    },

    /**净买入量统计*/
    getNetPurchasesStatisticInfo(data) {
        return http.get({
            url: '/admin/tradeStatistic/netPurchases',
            data
        })
    },

    /**交易量统计*/
    getTradeVolumeStatisticInfo(data) {
        return http.get({
            url: '/admin/tradeStatistic/tradeVolume',
            data
        })
    },

    /**配置交易活动参数*/
    buildTradeActivityConfig(data) {
        return http.post({
            url: '/admin/tradeStatistic/config',
            data,
            dataType: 'form'
        })
    },

    /**获取配置信息*/
    getTradeActivityConfig() {
        return http.get({
            url: '/admin/tradeStatistic/getConfig'
        })
    },

    /**获取配置信息*/
    getTradeAConfig() {
        return http.get({
            url: '/admin/tradeStatistic/config'
        })
    },

    /**清除交易统计*/
    clearTradeStatistic() {
        return http.post({
            url: '/admin/tradeStatistic/clear',
        })
    },

    /**平均买入成本统计*/
    getAvgCost(data) {
        return http.get({
            url: '/admin/tradeStatistic/buyAvgCost',
            data
        })
    },

    /**导出买入平均成本*/
    exportAvgCost(data) {
        return http.post({
            url: '/admin/tradeStatistic/exportAvgCost',
            data,
            dataType: 'form',
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    /**获取持仓分布数据*/
    getCoinAccount(data) {
        return http.get({
            url: '/admin/coinAccount/queryList',
            data
        })
    },

    exportCoinAccount(data) {
        return http.post({
            url: '/admin/coinAccount/export',
            data,
            dataType: 'form',
            responseType: 'blob'
        })
    },

    countSpotAccount(data) {
        return http.get({
            url: '/admin/coinAccount/count',
            data,
        })
    },

    /**查询交易对下单人数*/
    selectPairPerson(data) {
        return http.get({
            url: '/admin/tradePair/num',
            data
        })
    },

    selectPosition(data) {
        return http.get({
            url: '/admin/coinAccount/userPosition',
            data
        })
    },

    getSnapPosition(data) {
        return http.get({
            url: '/admin/coinAccount/snapPosition',
            data
        })
    },

    exportTradeDeal(data) {
        return http.post({
            url: '/admin/tradePair/deal/export',
            data,
            dataType: 'form',
            responseType: 'blob'
        })
    },

    exportTradeDealSingle(data) {
        return http.post({
            url: '/admin/tradePair/user/deal/export',
            data,
            dataType: 'form',
            responseType: 'blob'
        })
    },

    getPlateList(data) {
        return http.get({
            url: '/admin/plate/list',
            data
        })
    },
    plateDelete(data) {
        return http.post({
            url: '/admin/plate/delete',
            data,
            dataType: 'form'
        })
    },

    getPleteDetail(data) {
        return http.get({
            url: '/admin/plate/info',
            data
        })
    },

    plateUpdate(data) {
        return http.post({
            url: '/admin/plate/update',
            data,
        })
    },
    plateCreate(data) {
        return http.post({
            url: '/admin/plate/create',
            data,
        })
    },

}
